import mergeTheme from '../theme';

const BRAND_YELLOW = '#F9E547';

export default {
  Name: 'gold',
  Cobranded: false,
  BrochureUrl: 'https://www.goodrx.com',
  SquareLogoKey: 'goodrx.landscape.svg',
  LandscapeLogoKey: 'heydoctor-wordmark-dark.svg',
  BaseUrl: 'https://heydoctor.com',
  Business: {
    OfficePhone: '(415) 906-5937',
    HelpEmail: 'help@goodrx.com',
  },
  KickoutEnabled: false,
  Theme: mergeTheme({
    colors: {
      primaryLight: '#0049DA',
      primary: '#0049DB',
      secondary: '#F9E547',
      white: '#ffffff',

      grey: '#F0F0F4',
      greyDark: '#72727D',
      greyDarker: '#444444',
    },
    variants: {
      Button: {
        success: {
          backgroundColor: '#21B986',
        },
      },
    },
    typography: {
      headerFontFamily: 'Helvetica Neue',
      baseFontFamily: 'Helvetica Neue',
    },
    components: {
      header: {
        bgColor: BRAND_YELLOW,
        borderColor: BRAND_YELLOW,
        fontColor: '#000',
        logoHeight: 24,
        logoHeightMobile: 18,
      },
      auth: {
        rightPanelBg: BRAND_YELLOW,
        rightPanelFontColor: 'black',
      },
      footer: {
        logoWidth: 160,
      },
      chat: {
        fromCurrentUserbackground: '#DBE6FF',
        fromCurrentUserTextColor: '#222222',
        placeholderTextFontColor: '#6D6E71',
        placeholderFontSize: '14px',
        placeholderFontWeight: '400',
        fontSize: '15px',
        minHeight: '75px',
        sendButtonBottom: '15px',
        drawerHeaderBg: BRAND_YELLOW,
        drawerHeaderColor: 'black',
      },
    },
    styles: {
      Button: {
        borderRadius: 3,
      },
    },
  }),
};
